/**
 * Cities and major towns of Ethiopia, for the school "City / region" field.
 * `aka` holds older or alternative spellings so a search for "Nazret" still
 * finds Adama. Regions follow the 2023 administrative map.
 */
export interface EthiopianCity {
  name: string;
  region: string;
  aka?: string[];
}

export const ETHIOPIAN_CITIES: EthiopianCity[] = [
  // Chartered cities
  { name: 'Addis Ababa', region: 'Addis Ababa', aka: ['Finfinne', 'Addis Abeba'] },
  { name: 'Dire Dawa', region: 'Dire Dawa' },
  // Oromia
  { name: 'Adama', region: 'Oromia', aka: ['Nazret', 'Nazareth'] },
  { name: 'Bishoftu', region: 'Oromia', aka: ['Debre Zeit'] },
  { name: 'Jimma', region: 'Oromia' },
  { name: 'Shashemene', region: 'Oromia', aka: ['Shashamane'] },
  { name: 'Nekemte', region: 'Oromia', aka: ['Lekemt'] },
  { name: 'Asella', region: 'Oromia', aka: ['Asela'] },
  { name: 'Ambo', region: 'Oromia' },
  { name: 'Robe', region: 'Oromia', aka: ['Bale Robe'] },
  { name: 'Burayu', region: 'Oromia' },
  { name: 'Sebeta', region: 'Oromia' },
  { name: 'Sululta', region: 'Oromia' },
  { name: 'Holeta', region: 'Oromia' },
  { name: 'Dukem', region: 'Oromia' },
  { name: 'Gelan', region: 'Oromia' },
  { name: 'Legetafo', region: 'Oromia', aka: ['Legetafo Legedadi'] },
  { name: 'Sendafa', region: 'Oromia' },
  { name: 'Batu', region: 'Oromia', aka: ['Ziway', 'Zeway'] },
  { name: 'Mojo', region: 'Oromia', aka: ['Modjo'] },
  { name: 'Metehara', region: 'Oromia' },
  { name: 'Woliso', region: 'Oromia', aka: ['Ghion'] },
  { name: 'Fiche', region: 'Oromia', aka: ['Fitche'] },
  { name: 'Chancho', region: 'Oromia' },
  { name: 'Bedele', region: 'Oromia' },
  { name: 'Gimbi', region: 'Oromia' },
  { name: 'Dembi Dolo', region: 'Oromia', aka: ['Dembidolo'] },
  { name: 'Metu', region: 'Oromia', aka: ['Mettu'] },
  { name: 'Agaro', region: 'Oromia' },
  { name: 'Goba', region: 'Oromia' },
  { name: 'Ginir', region: 'Oromia' },
  { name: 'Negele Borana', region: 'Oromia', aka: ['Negele', 'Neghelle'] },
  { name: 'Yabelo', region: 'Oromia' },
  { name: 'Moyale', region: 'Oromia' },
  { name: 'Bule Hora', region: 'Oromia', aka: ['Hagere Mariam'] },
  { name: 'Shakiso', region: 'Oromia' },
  { name: 'Adola', region: 'Oromia' },
  { name: 'Chiro', region: 'Oromia', aka: ['Asebe Teferi'] },
  { name: 'Haramaya', region: 'Oromia', aka: ['Alemaya'] },
  { name: 'Arsi Negele', region: 'Oromia' },
  { name: 'Kofele', region: 'Oromia' },
  { name: 'Dodola', region: 'Oromia' },
  { name: 'Shambu', region: 'Oromia' },
  { name: 'Gerba Guracha', region: 'Oromia' },
  { name: 'Bako', region: 'Oromia' },
  { name: 'Nejo', region: 'Oromia' },
  { name: 'Mendi', region: 'Oromia' },
  { name: 'Huruta', region: 'Oromia' },
  { name: 'Bokoji', region: 'Oromia' },
  { name: 'Sire', region: 'Oromia' },
  // Amhara
  { name: 'Bahir Dar', region: 'Amhara', aka: ['Bahar Dar'] },
  { name: 'Gondar', region: 'Amhara', aka: ['Gonder'] },
  { name: 'Dessie', region: 'Amhara', aka: ['Dese'] },
  { name: 'Debre Markos', region: 'Amhara' },
  { name: 'Debre Birhan', region: 'Amhara', aka: ['Debre Berhan'] },
  { name: 'Debre Tabor', region: 'Amhara' },
  { name: 'Kombolcha', region: 'Amhara' },
  { name: 'Woldia', region: 'Amhara', aka: ['Weldiya'] },
  { name: 'Lalibela', region: 'Amhara' },
  { name: 'Finote Selam', region: 'Amhara' },
  { name: 'Injibara', region: 'Amhara' },
  { name: 'Dangila', region: 'Amhara' },
  { name: 'Kemise', region: 'Amhara' },
  { name: 'Ataye', region: 'Amhara' },
  { name: 'Sekota', region: 'Amhara' },
  { name: 'Mota', region: 'Amhara' },
  { name: 'Bichena', region: 'Amhara' },
  { name: 'Addis Zemen', region: 'Amhara' },
  { name: 'Metema', region: 'Amhara' },
  { name: 'Shewa Robit', region: 'Amhara' },
  { name: 'Debre Sina', region: 'Amhara' },
  { name: 'Mekane Selam', region: 'Amhara' },
  { name: 'Haik', region: 'Amhara', aka: ['Hayk'] },
  { name: 'Bati', region: 'Amhara' },
  { name: 'Kobo', region: 'Amhara' },
  { name: 'Woreta', region: 'Amhara' },
  { name: 'Debark', region: 'Amhara' },
  { name: 'Chagni', region: 'Amhara' },
  { name: 'Bure', region: 'Amhara' },
  { name: 'Merawi', region: 'Amhara' },
  { name: 'Debre Werk', region: 'Amhara' },
  { name: 'Enewari', region: 'Amhara' },
  // Tigray
  { name: 'Mekelle', region: 'Tigray', aka: ['Mekele', 'Makale'] },
  { name: 'Adigrat', region: 'Tigray' },
  { name: 'Axum', region: 'Tigray', aka: ['Aksum'] },
  { name: 'Shire', region: 'Tigray', aka: ['Inda Selassie', 'Endasilasie'] },
  { name: 'Adwa', region: 'Tigray' },
  { name: 'Humera', region: 'Tigray' },
  { name: 'Alamata', region: 'Tigray' },
  { name: 'Maychew', region: 'Tigray', aka: ['Maichew'] },
  { name: 'Wukro', region: 'Tigray' },
  { name: 'Abiy Addi', region: 'Tigray' },
  { name: 'Korem', region: 'Tigray' },
  { name: 'Sheraro', region: 'Tigray' },
  // Afar
  { name: 'Semera', region: 'Afar' },
  { name: 'Asaita', region: 'Afar', aka: ['Asayita'] },
  { name: 'Awash', region: 'Afar' },
  { name: 'Logiya', region: 'Afar' },
  { name: 'Dubti', region: 'Afar' },
  { name: 'Gewane', region: 'Afar' },
  { name: 'Abala', region: 'Afar' },
  // Somali
  { name: 'Jijiga', region: 'Somali', aka: ['Jigjiga'] },
  { name: 'Gode', region: 'Somali' },
  { name: 'Degehabur', region: 'Somali', aka: ['Dhagaxbuur'] },
  { name: 'Kebri Dahar', region: 'Somali', aka: ['Kabridahar'] },
  { name: 'Warder', region: 'Somali' },
  { name: 'Dolo Ado', region: 'Somali', aka: ['Dollo Ado'] },
  { name: 'Kelafo', region: 'Somali' },
  { name: 'Togochale', region: 'Somali', aka: ['Tog Wajaale'] },
  { name: 'Fik', region: 'Somali' },
  { name: 'Shinile', region: 'Somali' },
  // Harari
  { name: 'Harar', region: 'Harari', aka: ['Harer'] },
  // Sidama
  { name: 'Hawassa', region: 'Sidama', aka: ['Awassa'] },
  { name: 'Yirgalem', region: 'Sidama' },
  { name: 'Aleta Wondo', region: 'Sidama' },
  { name: 'Hula', region: 'Sidama', aka: ['Hagere Selam'] },
  { name: 'Daye', region: 'Sidama', aka: ['Bensa'] },
  // South Ethiopia
  { name: 'Wolaita Sodo', region: 'South Ethiopia', aka: ['Sodo', 'Soddo'] },
  { name: 'Arba Minch', region: 'South Ethiopia' },
  { name: 'Dilla', region: 'South Ethiopia' },
  { name: 'Jinka', region: 'South Ethiopia' },
  { name: 'Sawla', region: 'South Ethiopia' },
  { name: 'Karat', region: 'South Ethiopia', aka: ['Konso'] },
  { name: 'Yirgacheffe', region: 'South Ethiopia', aka: ['Yirga Chefe'] },
  { name: 'Boditi', region: 'South Ethiopia' },
  { name: 'Areka', region: 'South Ethiopia' },
  // Central Ethiopia
  { name: 'Hosaena', region: 'Central Ethiopia', aka: ['Hossana', 'Hosanna'] },
  { name: 'Butajira', region: 'Central Ethiopia' },
  { name: 'Wolkite', region: 'Central Ethiopia', aka: ['Welkite'] },
  { name: 'Worabe', region: 'Central Ethiopia' },
  { name: 'Durame', region: 'Central Ethiopia' },
  { name: 'Halaba Kulito', region: 'Central Ethiopia', aka: ['Alaba Kulito', 'Halaba'] },
  { name: 'Shone', region: 'Central Ethiopia' },
  { name: 'Gubre', region: 'Central Ethiopia' },
  // South West Ethiopia
  { name: 'Bonga', region: 'South West Ethiopia' },
  { name: 'Mizan Teferi', region: 'South West Ethiopia', aka: ['Mizan Aman'] },
  { name: 'Tepi', region: 'South West Ethiopia', aka: ['Teppi'] },
  { name: 'Tarcha', region: 'South West Ethiopia' },
  { name: 'Masha', region: 'South West Ethiopia' },
  // Benishangul-Gumuz
  { name: 'Asosa', region: 'Benishangul-Gumuz', aka: ['Assosa'] },
  { name: 'Gilgel Beles', region: 'Benishangul-Gumuz' },
  { name: 'Kamashi', region: 'Benishangul-Gumuz' },
  { name: 'Bambasi', region: 'Benishangul-Gumuz' },
  // Gambela
  { name: 'Gambela', region: 'Gambela', aka: ['Gambella'] },
  { name: 'Itang', region: 'Gambela' },
  { name: 'Abobo', region: 'Gambela' },
];

const norm = (s: string) => s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

/**
 * Up to `limit` suggestions for what the user has typed, best first:
 * names that start with it, then names with a later word (or an older
 * spelling) that starts with it, then names that merely contain it.
 * Empty input gives no suggestions.
 */
export function suggestCities(input: string, limit = 8): EthiopianCity[] {
  const q = norm(input);
  if (!q) return [];
  const tiers: EthiopianCity[][] = [[], [], []];
  for (const c of ETHIOPIAN_CITIES) {
    const names = [c.name, ...(c.aka ?? [])].map(norm);
    if (norm(c.name).startsWith(q)) tiers[0].push(c);
    else if (names.some((n) => n.startsWith(q) || n.split(' ').some((w) => w.startsWith(q)))) tiers[1].push(c);
    else if (names.some((n) => n.includes(q))) tiers[2].push(c);
  }
  const byName = (a: EthiopianCity, b: EthiopianCity) => a.name.localeCompare(b.name);
  return tiers.flatMap((t) => t.sort(byName)).slice(0, limit);
}
